








import { Component, Vue, Watch, Ref } from "vue-property-decorator";
import SelectEntity from "@/components/form/SelectEntity.vue";

import OrderItemPreview from "@/components/orders/OrderItemPreview.vue";
import { LearningRequest as ILearningRequest } from "@/api/models/learning-request";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import CustomTable from "@/components/form/CustomTable.vue";
import CPage from "@/components/form/CustomPage/CPage.vue";
import CField from "@/components/form/CField.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import OrderItemCard from "@/components/orders/OrderItemCard.vue";
import OrdersListKanban from "@/components/orders/OrdersListKanban.vue";
import api, { learningRequestApi } from "@/getinfo-api";
import LearningRequestFilter from "@/components/learning-request-v2/LearningRequestFilter.vue";
import LearningRequestTable from "@/components/learning-request-v2/LearningRequestTable.vue";
import ImportedUsersOrders from "@/components/orders/ImportedUsersOrders.vue";

@Component({
  components: {
    ImportedUsersOrders,
    LearningRequestTable,
    LearningRequestFilter,
    OrdersListKanban,
    CSingleSelect,
    CBlock,
    CField,
    CPage,
    CustomTable,
    CustomButton,
    OrderItemPreview,
    SelectEntity,
    CustomDatepicker,
    OrderItemCard
  }
})
export default class RequestHandling extends Vue {
  requestsIds: string[] = [];
  requests: ILearningRequest[] = [];
  data() {
    return {};
  }

  created() {
    if (typeof this.$route.query?.requestsIds === "string") {
      this.requestsIds = this.$route.query.requestsIds.split(",");

      this.requestsIds.forEach(id => {
        api.LearningRequestApi.get(id).then(res => {
          this.requests = [...this.requests, res.data];
        });
      });
    }
  }
}
